import { createFileRoute } from "@tanstack/react-router";

import AddInstagram from "@/features/onboarding/AddInstagram";
import BasicLayout from "@/layouts/Basic";

export const Route = createFileRoute("/_auth-basic/add-instagram")({
  component: () => (
    <BasicLayout>
      <AddInstagram />
    </BasicLayout>
  ),
});
